import authActions from './actions';

export default {
    state: {
        user: null,
        token: null,
        refreshtoken: null,
        tempToken: null,
        authenticated: false,
        modules: null,
        msg:null,
    },
    mutations: {
        setUserData(state, payLoad) {
            state.user = payLoad;
            state.token = payLoad.token;
            state.refreshtoken = payLoad.refreshtoken;
            state.modules = payLoad.modules;
            state.authenticated = true;
            localStorage.setItem('user', JSON.stringify(payLoad));
            localStorage.setItem('token', payLoad.token);
            localStorage.setItem('refreshtoken', payLoad.refreshtoken);
            localStorage.setItem('modules', JSON.stringify(payLoad.modules));
        },
        unsetUser(state) {
            state.user = null;
            state.token = null;
            state.refreshtoken = null;
            state.modules = null;
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            localStorage.removeItem("refreshtoken");
            localStorage.removeItem("modules");
            state.authenticated = false;
        },
        setTempToken(state, token) {
            state.tempToken = token;
        },
        setAuthToken(state, token) {
            localStorage.setItem('token', token);
            state.token = token;
        },
        setRefreshToken(state, token) {
            localStorage.setItem('refreshtoken',token);
            state.refreshtoken = token;
        },
        setMailmsg(state,payLoad){
            state.msg=payLoad
        },
        updateUserData(state, payLoad){
            state.user=payLoad,
            localStorage.setItem('user', JSON.stringify(payLoad));
        }
    },
    actions: authActions,
    getters: {
        getAuthToken(state) {
            return state.token;
        },
        getTempToken(state) {
            return state.tempToken;
        },
        getRefreshToken(state){
            return state.refreshtoken;
        },
        async isAuthenticated(state) {
             return  state.user && state.token && state.authenticated ? true : false;
        },
        getUser: (state) => state.user,
        getMsg: (state) => state.msg,
        getPermissions: (state) => state.modules,
        getUserPermissions: (state) => (allModules) => {
            const arr = state.modules
            if(!arr) return []
            const prm = allModules.filter( module => {
                const permission = arr.filter((permission) => ( module.id === permission.moduleId))
                return typeof(permission[0]) != "undefined" && permission[0] !== null && permission[0].canRead === 1
            })
            return prm;
        }
    },
    modules: {
      
    }
}